"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _broker = require("@/api/broker");
var _utils = require("@/utils");
var _vuex = require("vuex");
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    statusFilter: function statusFilter(val) {
      if (val === 0) {
        val = 'Confirmed';
      } else if (val === 1) {
        val = 'Unconfirmed';
      } else if (val === 2) {
        val = 'Paid';
      }
      return val;
    }
  },
  data: function data() {
    return {
      listLoading: false,
      settlement: {},
      dialogVisible: false,
      dialogType: 'new',
      list: [],
      anchorList: [],
      gear: {},
      total: 0,
      anchorTotal: 0,
      times: [],
      listQuery: {
        page: 1,
        size: 20,
        brokerId: '',
        startTime: '',
        endTime: ''
      },
      anchorListQuery: {
        brokerId: '',
        begin_date: '',
        page: 1,
        size: 20
      },
      totalListQuery: {
        begin_date: ''
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles'])), {}, {
    isBdRole: function isBdRole() {
      return this.roles.includes('bd');
    }
  }),
  watch: {
    '$route.query': {
      handler: function handler() {
        this.applyRouteQuery();
        this.getList();
      },
      deep: true
    },
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {
    this.applyRouteQuery();
    this.getList();
  },
  methods: {
    applyRouteQuery: function applyRouteQuery() {
      this.listQuery.brokerId = this.$route.query.brokerId || '';
      this.listQuery.page = 1;
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$settlementList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _broker.settlementList)(this.listQuery);
            case 1:
              _yield$settlementList = _context.v;
              code = _yield$settlementList.code;
              data = _yield$settlementList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleDetails: function handleDetails(row) {
      this.anchorListQuery.begin_date = (0, _utils.timeToUTCDateFilter)(row.begin_date, 'yyyy-MM-dd');
      this.anchorListQuery.brokerId = row.broker_id;
      this.anchorSettlementList();
      this.dialogVisible = true;
    },
    anchorSettlementList: function () {
      var _anchorSettlementList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$_anchorSettlem, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listLoading = true;
              _context2.n = 1;
              return (0, _broker.anchorSettlementList)(this.anchorListQuery);
            case 1:
              _yield$_anchorSettlem = _context2.v;
              code = _yield$_anchorSettlem.code;
              data = _yield$_anchorSettlem.data;
              this.listLoading = false;
              if (code === 0) {
                this.anchorList = data.list;
                this.anchorTotal = data.total;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function anchorSettlementList() {
        return _anchorSettlementList2.apply(this, arguments);
      }
      return anchorSettlementList;
    }(),
    handleStatus: function () {
      var _handleStatus = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(row) {
        var settlement_status, _yield$updateSettleSt, code;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              settlement_status = 0;
              _context3.n = 1;
              return (0, _broker.updateSettleStatus)({
                broker_id: row.broker_id,
                begin_date: (0, _utils.timeToUTCDateFilter)(row.begin_date, 'yyyy-MM-dd'),
                settlement_status: settlement_status
              });
            case 1:
              _yield$updateSettleSt = _context3.v;
              code = _yield$updateSettleSt.code;
              if (code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                row.settlement_status = settlement_status;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleStatus(_x) {
        return _handleStatus.apply(this, arguments);
      }
      return handleStatus;
    }(),
    userExport: function userExport() {
      window.open("/api/xls/settlementAnchor/export1?brokerId=".concat(this.anchorListQuery.brokerId, "&begin_date=").concat(this.anchorListQuery.begin_date));
    }
  }
};